import { createListTableColumns, ListTableColumn } from "sprint-common-web";

import { renderRecordType } from "../../../../common/utils/renderRecordType";
import { ConformingAssetListingItem } from "./ConformingAssetItem";
import { renderConformingAssetDetails } from "./renderConformingAssetDetails";

export interface CreateConformingAssetsSectionColumnsProps {
    isAnnotated(item: ConformingAssetListingItem): boolean | string;
    isDisabled(item: ConformingAssetListingItem): boolean;
    getHref(item: ConformingAssetListingItem): string;
    getTooltipText(item: ConformingAssetListingItem): string;
}

export const createConformingAssetsSectionColumns = (
    props: CreateConformingAssetsSectionColumnsProps
): ListTableColumn<ConformingAssetListingItem>[] => {
    const { isAnnotated, isDisabled, getHref, getTooltipText } = props;

    return createListTableColumns<ConformingAssetListingItem>([
        {
            type: "link",
            key: "path",
            name: "Path",
            minWidth: 300,
            maxWidth: 400,
            isAnnotated,
            isDisabled,
            getHref,
            getTooltipText
        },
        {
            type: "basic",
            key: "recordType",
            name: "Record type",
            minWidth: 100,
            maxWidth: 150,
            onRender: renderRecordType
        },
        {
            type: "basic",
            key: "details",
            name: "Details",
            minWidth: 200,
            maxWidth: 300,
            onRender: renderConformingAssetDetails
        }
    ]);
};
